export const API_URL = import.meta.env.VITE_BASE_URL
export const API_DEFAULT_URL = import.meta.env.VITE_DEFAULT_URL
export const APP_ENVIRONMENT = import.meta.env.VITE_APP_ENVIRONMENT
export const FEATURE_FLAG_URL = import.meta.env.VITE_FEATURE_FLAG_URL
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
export const DOMAIN_NAME = import.meta.env.VITE_DOMAIN_NAME
export const SENTRY_AUTH_TOKEN = import.meta.env.VITE_SENTRY_AUTH_TOKEN
export const WEB_SOCKET_URL = import.meta.env.VITE_WEB_SOCKET_URL
